// Test utility to manually trigger all timing activities for debugging
import { ActivityTimingTracker } from "../Utils/ActivityTimingTracker";

export class TimingTestUtility {
  public static async testAllActivities(): Promise<void> {
    console.log("🧪 Starting comprehensive timing test...");
    
    // Test all 7 activities
    const activities = [
      'InventoryCheck',
      'InventoryListUpdate', 
      'InventoryByQuoteUpdate',
      'BundleSelection',
      'ProductSkuAvailability',
      'BundleDetailsRetrieval',
      'ProductSearch'
    ];

    for (const activity of activities) {
      const startTime = ActivityTimingTracker.startActivity(activity);
      
      // Simulate some work with a small delay
      await new Promise(resolve => setTimeout(resolve, Math.random() * 100 + 50));
      
      ActivityTimingTracker.endActivity(activity, startTime);
    }

    console.log("🧪 Test completed! Checking results...");
    ActivityTimingTracker.debugCurrentState();
    ActivityTimingTracker.logTimingSummary();
    
    const allTimings = ActivityTimingTracker.getAllTimings();
    console.log("🧪 Final test results:", allTimings);
    
    return;
  }

  public static clearAndTest(): void {
    console.log("🧪 Clearing existing timings and running test...");
    ActivityTimingTracker.clearTimings();
    this.testAllActivities();
  }
}

// Global access for browser console testing
(window as any).TimingTestUtility = TimingTestUtility;
